export enum MovementOperation {
    PREPARE = 'PREPARE',
    START = 'START',
    FINISH = 'FINISH',
    CANCEL_PREPARE = 'CANCEL_PREPARE',
    CANCEL_START = 'CANCEL_START',
    CANCEL_MOVEMENT = 'CANCEL_MOVEMENT',
    FINISH_YARD = 'FINISH_YARD',
    CANCEL_START_YARD = 'CANCEL_START_YARD',
    CANCEL_PREPARE_YARD = 'CANCEL_PREPARE_YARD',
    START_YARD = 'START_YARD',
    PREPARE_YARD = 'PREPARE_YARD',
    AUTHORIZE = 'AUTHORIZE',
    CANCEL_AUTHORIZATION = 'CANCEL_AUTHORIZATION'
}